import React from "react";
import SEO from "../common/SEO";
import Layout from "../common/Layout";
import BreadcrumbOne from "../elements/breadcrumb/BreadcrumbOne";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import AccordionOne from "../elements/accordion/AccordionOne";
import FooterTwo from "../common/footer/FooterTwo";
import Copyright from "../common/footer/Copyright";

const FAQ = () => {
  return (
    <>
      <SEO
        title="FAQ || WhatsOn Agency"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What is the best digital agency in UK?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Whatson Digital Agency is recognized as one of the leading digital agencies in UK, providing SEO, Google Ads, social media marketing, content creation, and website development services that help businesses grow online."
              }
            },
            {
              "@type": "Question",
              "name": "What is the best digital agency in Dhaka?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Based in Dhaka, Whatson Digital Agency serves both local and international clients with result-driven digital marketing solutions, including Facebook Ads, Google Ads, SEO, and YouTube marketing."
              }
            },
            {
              "@type": "Question",
              "name": "What is the best Facebook Ads boost agency in UK?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We specialize in high-performing Facebook Ads campaigns that increase reach, engagement, and sales. Our data-driven strategies make us one of the top agencies for Facebook Ads in UK."
              }
            },
            {
              "@type": "Question",
              "name": "What services does Whatson Digital Agency offer?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide a full range of digital marketing solutions including SEO, Google Ads, social media marketing, YouTube growth strategies, content marketing, and website development."
              }
            },
            {
              "@type": "Question",
              "name": "How can Whatson help my business grow online?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Through customized marketing strategies, campaign optimization, and continuous performance tracking, we help increase website traffic, social media engagement, and overall sales for your business."
              }
            },
            {
              "@type": "Question",
              "name": "How long does it take to see results from SEO or ads?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "SEO results usually appear within 3–6 months, while paid campaigns like Facebook, Google, or YouTube Ads can deliver measurable results within days or weeks."
              }
            },
            {
              "@type": "Question",
              "name": "Do you work with international clients?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we provide digital marketing services to clients including the UK, USA, and other countries."
              }
            },
            {
              "@type": "Question",
              "name": "How do you charge for your services?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Our pricing is flexible and depends on the type of service and project scope. We offer custom packages for SEO, social media, paid ads, website design and development, and full digital marketing strategies."
              }
            },
            {
              "@type": "Question",
              "name": "Do I need to give account access for digital campaigns?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, limited access to your website, social media accounts, or Google Ads is needed to manage campaigns effectively. All access is handled securely and confidentially."
              }
            },
            {
              "@type": "Question",
              "name": "How do I get started with Whatson Digital Agency?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Simply contact us via our website or email, share your business goals, and we’ll create a custom strategy to grow your online presence."
              }
            }
          ]
        }}
      />
      <Layout>
        <BreadcrumbOne
          title="Frequently Asked Questions"
          rootUrl="/"
          parentUrl="Home"
          currentUrl="FAQ"
        />

        <div className="main-content">
          <div className="rn-accordion-area rn-section-gap rn-faq-hero">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <SectionTitle
                    textAlign="text-center"
                    radiusRounded=""
                    subtitle="FAQ"
                    title="Find Answers Quickly"
                    description=""
                  />
                </div>
              </div>
              <div className="row mt--35 row--20">
                <div className="col-lg-10 offset-lg-1">
                  <AccordionOne customStyle="rn-accordion-fancy" />
                </div>
              </div>
            </div>
          </div>
          <FooterTwo />
        </div>
      </Layout>
      <Copyright />
    </>
  );
};

export default FAQ;
